import './App.css';
import {
  BrowserRouter,
  Navigate,
  Routes,
  Route
} from "react-router-dom";
import LoginPage from './page/login';
import DashBoard from './page/dashboard'
//** Reservation **/
import Reservation from './page/reservation/reservation';
import NotReservation from './page/reservation/notreservation';
import TotalReservation from './page/reservation/total_reservation';
import PublicReserve from './page/orders/public_reservation.js';
import PublicDetail from './page/orders/public_detail.js';
import ReserveAS from './page/reservation/reserve_as.js';
import ASDetail from './page/reservation/detail_as.js';
import ListDetail from './page/reservation/table_detail';
//** Management **/
import Cost from './page/management/cost/cost.js';
import CostDetail from './page/management/cost/costdetail.js';
import Manager from './page/management/manager/manager.js';
import AddManager from './page/management/manager/add_manager.js';
import ManagerDetail from './page/management/manager/manager_detail.js';
import RequestManager from './page/management/manager/request_manager.js';
import User from './page/management/user/user.js';
import Staff from './page/management/staff/staff.js';
import StaffDetail from './page/management/staff/staff_detail.js';
import ActionLog from './page/management/log/actionlog.js';
import Coupon from './page/management/coupon/coupon.js';
import DetailCoupon from './page/management/coupon/detail_coupon.js';

import Biling from './page/management/biling/biling.js';
import TotalBiling from './page/management/biling/total_biling.js';
import AccountDeletion from './page/management/user/account_deletion.js';
import Training from './page/management/training/training.js';
import PopupSettings from './page/management/popup/popup_settings.js';
import AppVersionSettings from './page/management/app_version/app_version_settings.js';
import IotDevices from './page/management/iot/iot_devices.js';
import AppLibrary from './page/management/app_library/app_library.js';
import IotDeviceDetail from './page/management/iot/iot_device_detail.js';
import IotControlLogs from './page/management/iot/iot_control_logs.js';
import IotAppPrototype from './page/management/iot/iot_app_prototype.js';
//** Notice/Event **/
import Notice from './page/notices_events/notice.js';
import NoticeDetail from './page/notices_events/notice_detail.js';
import Event from './page/notices_events/event.js';
import EventDetail from './page/notices_events/event_detail.js';
import ManagerNotice from './page/notices_events/manager/manager_notice.js';
import ManagerNoticeDetail from './page/notices_events/manager/manager_notice_detail.js';
import ManagerEvent from './page/notices_events/manager/manager_event.js';
import ManagerEventDetail from './page/notices_events/manager/manager_event_detail.js';
import QuotationPage from './page/orders/quotation.js';
import QuotationList from './page/orders/quotation_list.js';
import QuotationDetail from './page/orders/quotation_detail.js';
import NoticeList from './page/orders/NoticeList.js';
import NoticeListDetail from './page/orders/notice_list_detail.js';
import CouponUsage from './page/orders/coupon_usage.js';
import PointUsage from './page/orders/point_usage.js';
//** Common **/
import ProtectedLayout from './page/common/ProtectedLayout.js';
import PermissionGuard from './page/common/PermissionGuard.js';
import FeatureGuard from './page/common/FeatureGuard.js';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<LoginPage />}></Route>
        <Route path="iot_app_prototype" element={<IotAppPrototype />}></Route>
        <Route element={<ProtectedLayout />}>
          <Route path="dashboard" element={<DashBoard />}></Route>
          <Route path="reserve" element={<PermissionGuard required="today_reservation_manage"><Reservation /></PermissionGuard>}></Route>
          <Route path="notreserve" element={<PermissionGuard required="unprocessed_reservation_manage"><NotReservation /></PermissionGuard>}></Route>
          <Route path="totalreserve" element={<PermissionGuard required="total_reservation_manage"><TotalReservation /></PermissionGuard>}></Route>
          <Route path='cost' element={<PermissionGuard required="cost_manage"><Cost /></PermissionGuard>}></Route>
          <Route path="manager" element={<PermissionGuard required="manager_manage"><Manager /></PermissionGuard>}></Route>
          <Route path="addmanager" element={<PermissionGuard required="manager_manage"><AddManager /></PermissionGuard>}></Route>
          <Route path="managerdetail" element={<PermissionGuard required="manager_manage"><ManagerDetail /></PermissionGuard>}></Route>
          <Route path="request_manager" element={<PermissionGuard required="manager_request_manage"><RequestManager /></PermissionGuard>}></Route>
          <Route path="listdetail" element={<ListDetail />}></Route>
          <Route path="costdetail" element={<PermissionGuard required="cost_manage"><CostDetail /></PermissionGuard>}></Route>
          <Route path="user" element={<PermissionGuard required="user_manage"><User /></PermissionGuard>}></Route>
          <Route path="staff" element={<PermissionGuard adminOnly={true}><Staff /></PermissionGuard>}></Route>
          <Route path="staff_detail" element={<PermissionGuard adminOnly={true}><StaffDetail /></PermissionGuard>}></Route>
          <Route path="public_reservation" element={<PermissionGuard required="bulk_order_manage"><PublicReserve /></PermissionGuard>}></Route>
          <Route path="public_detail" element={<PermissionGuard required="bulk_order_manage"><PublicDetail /></PermissionGuard>}></Route>
          <Route path="action_log" element={<PermissionGuard required="action_log_view"><ActionLog /></PermissionGuard>}></Route>
          <Route path="notice" element={<PermissionGuard required="user_notice_manage"><Notice /></PermissionGuard>}></Route>
          <Route path="notice_detail" element={<PermissionGuard required="user_notice_manage"><NoticeDetail /></PermissionGuard>}></Route>
          <Route path="event" element={<PermissionGuard required="user_event_manage"><Event /></PermissionGuard>}></Route>
          <Route path="event_detail" element={<PermissionGuard required="user_event_manage"><EventDetail /></PermissionGuard>}></Route>
          <Route path="manager-notices" element={<PermissionGuard required="manager_notice_manage"><ManagerNotice /></PermissionGuard>}></Route>
          <Route path="manager-notice-detail" element={<PermissionGuard required="manager_notice_manage"><ManagerNoticeDetail /></PermissionGuard>}></Route>
          <Route path="manager-events" element={<PermissionGuard required="manager_event_manage"><ManagerEvent /></PermissionGuard>}></Route>
          <Route path="manager-event-detail" element={<PermissionGuard required="manager_event_manage"><ManagerEventDetail /></PermissionGuard>}></Route>
          <Route path="reserve_as" element={<PermissionGuard required="as_manage"><ReserveAS /></PermissionGuard>}></Route>
          <Route path="detail_as" element={<PermissionGuard required="as_manage"><ASDetail /></PermissionGuard>}></Route>

          <Route path="coupon" element={<PermissionGuard required="coupon_manage"><Coupon /></PermissionGuard>}></Route>
          <Route path="detail_coupon" element={<PermissionGuard required="coupon_manage"><DetailCoupon /></PermissionGuard>}></Route>
          <Route path="biling" element={<PermissionGuard required="bilings"><Biling /></PermissionGuard>}></Route>
          <Route path="total_biling" element={<PermissionGuard required="bilings"><TotalBiling /></PermissionGuard>}></Route>
          <Route path='account_deletion' element={<PermissionGuard required="user_leave_manage"><AccountDeletion /></PermissionGuard>}></Route>
          <Route path="training" element={<PermissionGuard required="training_manage"><Training /></PermissionGuard>}></Route>
          <Route path="popup_settings" element={<PermissionGuard requiredAny={["popup_manage", "benefit_event_manage"]}><PopupSettings /></PermissionGuard>}></Route>
          <Route path="app_version_settings" element={<PermissionGuard required="app_version_manage"><AppVersionSettings /></PermissionGuard>}></Route>
          <Route path="iot_devices" element={<FeatureGuard feature="iot"><IotDevices /></FeatureGuard>}></Route>
          <Route path="app_library" element={<FeatureGuard feature="appLibrary"><AppLibrary /></FeatureGuard>}></Route>
          <Route path="iot_device_detail" element={<FeatureGuard feature="iot"><IotDeviceDetail /></FeatureGuard>}></Route>
          <Route path="iot_control_logs" element={<FeatureGuard feature="iot"><IotControlLogs /></FeatureGuard>}></Route>
          {/* 가입혜택관리는 팝업관리 탭으로 통합됨 — 기존 북마크·딥링크는 리다이렉트한다 */}
          <Route path="benefit_events" element={<Navigate to="/popup_settings" replace />}></Route>
          <Route path="quotation" element={<PermissionGuard required="quotation_manage"><QuotationPage /></PermissionGuard>}></Route>
          <Route path="quotation_list" element={<PermissionGuard required="quotation_manage"><QuotationList /></PermissionGuard>}></Route>
          <Route path="quotation_detail" element={<PermissionGuard required="quotation_manage"><QuotationDetail /></PermissionGuard>}></Route>
          <Route path="notice_list" element={<NoticeList />}></Route>
          <Route path="noticelist_detail" element={<NoticeListDetail />}></Route>
          <Route path="coupon_usage" element={<PermissionGuard required="coupon_manage"><CouponUsage /></PermissionGuard>}></Route>
          <Route path="point_usage" element={<PermissionGuard required="coupon_manage"><PointUsage /></PermissionGuard>}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
